export const getLabelWithAsterisk = (label: React.ReactNode, required?: boolean): React.ReactNode => {
    if (!required) return label;

    return (
        <span>
            {label} <span>*</span>
        </span>
    );
};
